import React from 'react';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import LedgerAccountForm from './LedgerAccountForm';

// Rename the name of the function:
const LedgerAccountList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_ledgeraccount_list',
        defaultParams: { 'is_active': true },
        object: 'ledgeraccount'
    }
    const groupByField = {
        field: 'ledger_account_type',
        translateValue: true
    }
    const objectName = 'ledgeraccount.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deactivated'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <LedgerAccountForm />;
    const onRowClick = 'editModal'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'ledger_code', label: 'ledgeraccount.general.ledger_account_label' },
        { width: '12fr', field: 'name', label: '' },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'ledgeraccount.general.active_ledger_accounts_label',
            params: { 'is_active': true }
        },
        {
            id: 'inactive',
            label: 'ledgeraccount.general.inactive_ledger_accounts_label',
            params: { 'is_active': false }
        }
    ]

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            filters={filters}
            columns={columns}
            groupByField={groupByField}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            onRowClick={onRowClick}
            isPaginated={isPaginated}
        />
    );
};

export default LedgerAccountList;